import { EXH_STALL_POSSESSION_CHECKLIST_LIST, EXH_STALL_POSSESSION_CHECKLIST_DETAILS,EXH_UPDATE_STALL_POSSESSION_CHECKLIST, VERIFY_STALL_POSSESSION_QR } from "../../../utils/constants";


const initialState = [];

function exhStallPossessionChecklistReducer(state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
        case EXH_STALL_POSSESSION_CHECKLIST_LIST:
            return [...state, payload];
        case EXH_STALL_POSSESSION_CHECKLIST_DETAILS:
            return [...state, payload];
        case EXH_UPDATE_STALL_POSSESSION_CHECKLIST:
            return [...state, payload];
        case VERIFY_STALL_POSSESSION_QR:
            return [...state, payload];
        default:
            return state;
    }
};

export default exhStallPossessionChecklistReducer;